<div class="card block isMinimizable">
    <div class="card-header">
        <div class="card-title">
            <i class="fa fa-angle-up"></i>
            <h2>Évolution du nombre d'entreprises</h2>
        </div>
    </div>
    <div class="card-body col-md-12">
        <img *ngIf="preview" src="assets/widgets/ss_entreprises.PNG" class="img-fluid" />
        <app-upgrade-plan *ngIf="!authenticationService.isAllowed('basique')  && !preview" plan="Basique" preview="assets/widgets/ss_entreprises.PNG"></app-upgrade-plan>
        <div class="card-text row" *ngIf="authenticationService.isAllowed('basique')  && !preview">
            <div echarts [options]="options" [merge]="data" class="chart" (chartInit)="onChartInit($event)"></div>
        </div>
    </div>
</div>
